<template>
  <div
    id="mtm"
    v-if="
      $store.state.global_matriz_peligro_cliente.length > 0 ||
      $store.state.global_matriz_peligro_cliente_movil.length > 0
    "
    class="col-sm-12 container-fluid bg-light mt-5 container-mtm"
  >
    <div class="tab-content">
      <div class="container-fluid">
        <div class="row">
          <div
            v-if="$store.state.global_matriz_peligro_cliente_movil.length > 0"
          >
            <!-- TABLA VERSIÓN MÓVIL -->
            <v-client-table
              class="container"
              :columns="columnsMovil"
              :data="$store.state.global_matriz_peligro_cliente_movil"
              :options="optionsMovil"
            >
              <div slot="procesoMovil" slot-scope="props">
                <div class="card p-1 v-movil-divs">
                  <div class="card-body v-movil-divs">
                    <h6 class="card-title text-justify">
                      <b>Proceso Móvil:</b> {{ props.row.proceso_riesgo }}
                    </h6>
                    <h6 class="card-title text-justify">
                      <b>Zona:</b> {{ props.row.zona }}
                    </h6>
                    <h6 class="card-title text-justify">
                      <b>Actividades:</b> {{ props.row.actividad }}
                    </h6>
                    <h6 class="card-title text-justify">
                      <b>Tareas:</b> {{ props.row.tarea }}
                    </h6>
                    <h6 class="card-title text-justify">
                      <b>Rutinario:</b> {{ props.row.rutinario_peligro }}
                    </h6>

                    <div
                      v-for="(item, indexx) in props.row.lista_peligros"
                      :key="item.id_matriz + indexx"
                      :id="'carouselControls' + item.id_matriz + indexx"
                      class="carousel slide"
                      data-ride="carousel"
                    >
                      <div v-if="indexx == 1">
                        <div class="carousel-inner">
                          <div
                            v-for="(item, index) in props.row.lista_peligros"
                            :key="item.id_matriz"
                            class="carousel-item"
                            :class="{ active: index === 0 }"
                          >
                            <div class="card bg-light v-movil-divs pl-0">
                              <div class="card-body v-movil-divs pl-1">
                                <div class="card-text">
                                  <b>Clasificación</b> <br />
                                  <h6 class="card-subtitle mb-2 text-muted">
                                    {{ item.clasificacion }}
                                  </h6>
                                </div>
                                <div class="card-text">
                                  <b>Subclasificación</b> <br />
                                  <h6 class="card-subtitle mb-2 text-muted">
                                    {{ item.subclasificacion }}
                                  </h6>
                                </div>
                                <div class="card-text">
                                  <b>Descripción</b> <br />
                                  <h6 class="card-subtitle mb-2 text-muted">
                                    {{ item.descripcion }}
                                  </h6>
                                </div>
                                <center>
                                  <button
                                    class="btn btn-block btn-form"
                                    data-toggle="modal"
                                    data-target="#id_peligro_modal"
                                    @click="query_peligro_vm(item.id_matriz)"
                                  >
                                    Consultar
                                  </button>
                                </center>
                              </div>
                            </div>
                          </div>
                        </div>
                        <a
                          class="carousel-control-prev"
                          :href="'#carouselControls' + item.id_matriz + indexx"
                          role="button"
                          data-slide="prev"
                        >
                          <span
                            class="carousel-control-prev-icon text-dark"
                            aria-hidden="true"
                          ></span>
                          <span class="sr-only">Anterior</span>
                        </a>
                        <a
                          class="carousel-control-next"
                          :href="'#carouselControls' + item.id_matriz + indexx"
                          role="button"
                          data-slide="next"
                        >
                          <span
                            class="carousel-control-next-icon"
                            aria-hidden="true"
                          ></span>
                          <span class="sr-only">Siguiente</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-client-table>
            <!-- FIN TABLA VERSIÓN MÓVIL -->
          </div>

          <!-- MODAL EVALUACIÓN DE RIESGOS -->
          <div
            class="modal fade"
            id="id_peligro_modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
              <div class="modal-content v-movil-divs">
                <div class="modal-header border-bottom-0">
                  <h5 class="modal-title" id="staticBackdropLabel">
                    {{ clasificacion_movil }}
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  class="modal-body v-movil-divs bg-light m-2"
                  style="height: 500px"
                >
                  <b class="pb-1">Efectos Posibles</b> <br />
                  <h6 class="card-subtitle mb-2 text-muted">
                    {{ efecto_posible_movil }}
                  </h6>
                  <hr />

                  <b>Controles Existentes</b> <br />
                  <center>
                    <button
                      type="button"
                      class="btn btn-block btn_general font-weight-bold mb-2"
                      style="width: 70%"
                      :style="[
                        fuente_movil != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            },
                      ]"
                      @click="mostrar_controles_fuente(id_matriz_movil)"
                      data-toggle="modal"
                      data-target="#modal_controles_existentes_fuente_movil"
                    >
                      Fuente
                    </button>

                    <button
                      type="button"
                      class="btn btn-block btn_general font-weight-bold mb-2"
                      style="width: 70%"
                      :style="[
                        medio_movil != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            },
                      ]"
                      @click="mostrar_controles_medio(id_matriz_movil)"
                      data-toggle="modal"
                      data-target="#modal_controles_existentes_medio_movil"
                    >
                      Medio
                    </button>

                    <button
                      type="button"
                      class="btn btn-block btn_general font-weight-bold mb-2"
                      style="width: 70%"
                      :style="[
                        individuo_movil != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            },
                      ]"
                      @click="mostrar_controles_individuo(id_matriz_movil)"
                      data-toggle="modal"
                      data-target="#modal_controles_existentes_individuo_movil"
                    >
                      Individuo
                    </button>
                  </center>
                  <hr />

                  <b class="pb-1">Evaluación de Riesgo</b> <br />
                  <center>
                    <button
                      type="text"
                      class="btn btn-sm btn_general font-weight-bold"
                      style="width: 70%"
                      :style="class_btn_alerts_movil"
                      @click="
                        consultar_evaluacion_riesgo(
                          id_matriz_movil,
                          class_btn_outline_movil,
                          class_btn_alerts_movil
                        )
                      "
                      readonly
                      required
                      data-toggle="modal"
                      data-target="#modal_evaluacion_riesgo_movil"
                    >
                      {{ aceptabilidad_movil }}
                    </button>
                  </center>
                  <hr />
                  <b class="pb-1">Criterios Controles</b> <br />
                  <h6>
                    Expuestos:
                    <a
                      class="text-muted"
                      v-if="num_expuestos_movil == undefined"
                      >N/A</a
                    >
                    <a class="text-muted" v-else>{{ num_expuestos_movil }}</a>
                  </h6>

                  <h6>
                    Requisito legal:
                    <a
                      class="text-muted"
                      v-if="requisito_legal_movil == undefined"
                      >No Aplica</a
                    >
                    <a class="text-muted" v-else>{{ requisito_legal_movil }}</a>
                  </h6>

                  <h6>Peor consecuencia:</h6>
                  <p
                    class="text-muted"
                    v-if="peor_consecuencia_movil == undefined"
                  >
                    N/A
                  </p>
                  <p class="text-muted" v-else>{{ peor_consecuencia_movil }}</p>

                  <b class="pb-1">Medidas Intervención</b> <br />
                  <center>
                    <button
                      type="button"
                      class="btn btn-block btn_general font-weight-bold mb-2"
                      style="width: 70%"
                      :style="[
                        eliminacion_movil != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_eliminacion(
                          id_matriz_movil
                        )
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_eliminacion_movil"
                    >
                      Eliminación
                    </button>

                    <button
                      type="button"
                      class="btn btn-block btn_general font-weight-bold mb-2"
                      style="width: 70%"
                      :style="[
                        sustitucion_movil != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_sustitucion(
                          id_matriz_movil
                        )
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_sustitucion_movil"
                    >
                      Sustitución
                    </button>

                    <button
                      type="button"
                      class="btn btn-block btn_general font-weight-bold mb-2"
                      style="width: 70%"
                      :style="[
                        controles_ing_movil != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_controles(
                          id_matriz_movil
                        )
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_controles_movil"
                    >
                      Controles de Ingeniería
                    </button>

                    <button
                      type="button"
                      class="btn btn-block btn_general font-weight-bold mb-2"
                      style="width: 70%"
                      :style="[
                        controles_admin_movil != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_controles_admin(
                          id_matriz_movil
                        )
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_controles_admin_movil"
                    >
                      Controles Administrativos
                    </button>

                    <button
                      type="button"
                      class="btn btn-block btn_general font-weight-bold mb-2"
                      style="width: 70%"
                      :style="[
                        equipos_movil != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_equipos(id_matriz_movil)
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_equipos_movil"
                    >
                      Elementos de Protección Personal
                    </button>
                  </center>
                </div>
                <div
                  class="
                    modal-footer
                    border-top-0
                    d-flex
                    justify-content-center
                  "
                >
                  <div
                    class="btn-group dropup dropdown-centered"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    :disabled="
                      $store.state.global_nuevo_peligro ||
                      $store.state.global_es_editar
                    "
                  >
                    <button
                      type="button"
                      class="btn dropdown-toggle boton_12"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Opciones
                    </button>
                    <div class="dropdown-menu b-dropdown-opt">
                      <a
                        class="mi_boton"
                        @click="editar_peligro(id_matriz_movil)"
                      >
                        &nbsp;<b>Editar Peligro</b>
                      </a>
                      <hr />
                      <a
                        class="mi_boton"
                        @click="
                          nuevo_peligro(
                            id_proceso_movil,
                            proceso_riesgo_movil,
                            id_zona_movil,
                            zona_movil,
                            id_actividad_movil,
                            actividad_movil,
                            id_tareas_movil,
                            tarea_movil,
                            rutinario_peligro_movil
                          )
                        "
                      >
                        &nbsp;<b>Nuevo Peligro</b>
                      </a>
                      <hr />
                      <a
                        class="mi_boton"
                        @click="eliminar_peligro(id_matriz_movil)"
                      >
                        &nbsp;<b>Eliminar Peligro</b>
                      </a>
                      <hr />
                      <a
                        class="mi_boton"
                        @click="
                          eliminar_proceso(
                            id_proceso_movil,
                            id_zona_movil,
                            id_actividad_movil,
                            id_tareas_movil
                          )
                        "
                      >
                        &nbsp;<b>Eliminar Proceso</b>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- TABLA VERSIÓN ESCRITORIO -->
          <div
            class="col-sm-12 matriz-peligros"
            v-if="$store.state.global_matriz_peligro_cliente.length > 0"
          >
            <v-client-table
              :columns="columns"
              :data="$store.state.global_matriz_peligro_cliente"
              :options="options"
            >
              <!-- PROCESO -->
              <div slot="proceso_riesgo" slot-scope="props">
                <div class="contenedor-basico-tabla">
                  <div class="contenedor-peligro--item">
                    <div class="contenedor-peligro--item__izquierda">
                      <h6>Proceso:</h6>
                      <p style="margin-left: 20px">
                        {{ props.row.proceso_riesgo }}
                      </p>
                    </div>
                  </div>
                  <!-- ZONA -->
                  <div class="contenedor-peligro--item">
                    <div class="contenedor-peligro--item__izquierda">
                      <h6>Zona:</h6>
                      <p style="margin-left: 41px">{{ props.row.zona }}</p>
                    </div>
                  </div>
                  <!-- ACTIVIDADES -->
                  <div class="contenedor-peligro--item">
                    <div class="contenedor-peligro--item__centrado">
                      <h4>Actividades</h4>
                      <p>{{ props.row.actividad }}</p>
                    </div>
                  </div>
                  <!-- TAREAS -->
                  <div class="contenedor-peligro--item">
                    <div class="contenedor-peligro--item__centrado">
                      <h4>Tareas</h4>
                      <p>{{ props.row.tarea }}</p>
                    </div>
                  </div>
                  <!-- RUTINARIO -->
                  <div class="contenedor-peligro--item">
                    <div class="contenedor-peligro--item__izquierda">
                      <h6>Rutinario:</h6>
                      <p>{{ props.row.rutinario_peligro }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- PELIGRO -->
              <div slot="peligro" slot-scope="props">
                <div
                  v-for="(item, index) in props.row.lista_peligros"
                  :key="index.item"
                  class="contenedor-basico-tabla"
                >
                  <!-- CLASIFICACIÓN -->
                  <div class="contenedor-peligro--item">
                    <div class="contenedor-peligro--item__izquierda">
                      <h6>Clasificación:</h6>
                      <p style="margin-left: 36px">
                        {{ item.clasificacion }}
                      </p>
                    </div>
                  </div>
                  <!-- SUBCLASIFICACIÓN -->
                  <div class="contenedor-peligro--item">
                    <div class="contenedor-peligro--item__izquierda">
                      <h6>Subclasificación:</h6>
                      <p>{{ item.subclasificacion }}</p>
                    </div>
                  </div>
                  <!-- DESCRIPCIÓN -->
                  <div class="contenedor-peligro--item">
                    <div class="contenedor-peligro--item__izquierda">
                      <h6>Descripción:</h6>
                      <p>{{ item.descripcion }}</p>
                    </div>
                  </div>
                  <!-- FIN -->
                </div>
              </div>
              <!-- MOSTRAR EFECTOS -->
              <div slot="e_efecto_posible" slot-scope="props">
                <div
                  v-for="(item, index) in props.row.lista_peligros"
                  :key="index.item"
                  class="contenedor-basico-tabla"
                >
                  <div class="contenedor-basico-tabla contenedor-celdas">
                    <p>{{ item.efecto_posible }}</p>
                  </div>
                </div>
              </div>
              <!-- MOSTRAR CONTROLES EXISTENTES -->
              <div slot="controles_existentes" slot-scope="props">
                <div
                  v-for="(item, index) in props.row.lista_peligros"
                  :key="index.item"
                  class="contenedor-basico-tabla"
                >
                  <div class="contenedor-basico-botones">
                    <button
                      type="button"
                      class="btn btn-sm btn_general font-weight-bold"
                      :style="[
                        item.fuente != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            },
                      ]"
                      @click="mostrar_controles_fuente(item.id_matriz)"
                      data-toggle="modal"
                      data-target="#modal_controles_existentes_fuente"
                    >
                      Fuente
                    </button>

                    <button
                      type="button"
                      class="btn btn-sm btn_general font-weight-bold"
                      :style="[
                        item.medio != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            },
                      ]"
                      @click="mostrar_controles_medio(item.id_matriz)"
                      data-toggle="modal"
                      data-target="#modal_controles_existentes_medio"
                    >
                      Medio
                    </button>

                    <button
                      type="button"
                      class="btn btn-sm btn_general font-weight-bold"
                      :style="[
                        item.individuo != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            },
                      ]"
                      @click="mostrar_controles_individuo(item.id_matriz)"
                      data-toggle="modal"
                      data-target="#modal_controles_existentes_individuo"
                    >
                      Individuo
                    </button>
                  </div>
                </div>
              </div>
              <!-- MOSTRAR EVALUACIÓN RIESGO -->
              <div slot="evaluacion_riesgo" slot-scope="props">
                <div
                  v-for="(item, index) in props.row.lista_peligros"
                  :key="index.item"
                  class="contenedor-basico-tabla"
                >
                  <div class="contenedor-basico-botones">
                    <button
                      type="text"
                      class="btn btn-sm btn_general font-weight-bold"
                      :style="item.class_btn_alerts"
                      @click="
                        consultar_evaluacion_riesgo(
                          item.id_matriz,
                          item.class_btn_outline,
                          item.class_btn_alerts
                        )
                      "
                      readonly
                      required
                      data-toggle="modal"
                    >
                      {{ item.aceptabilidad }}
                    </button>
                  </div>
                </div>
              </div>
              <!-- MOSTRAR CRITERIOS CONTROLES -->
              <div slot="criterios_controles" slot-scope="props">
                <div
                  v-for="(item, index) in props.row.lista_peligros"
                  :key="index"
                  class="contenedor-basico-tabla"
                >
                  <div class="contenedor-peligro contenedor-celdas">
                    <div class="contenedor-peligro--item">
                      <div class="contenedor-peligro--item__izquierda">
                        <h6>Expuestos:</h6>
                        <p style="margin-left: 46px">
                          {{ item.num_expuestos }}
                        </p>
                      </div>
                    </div>
                    <div class="contenedor-peligro--item">
                      <div class="contenedor-peligro--item__izquierda">
                        <h6>Requisito legal:</h6>
                        <p>{{ item.requisito_legal }}</p>
                      </div>
                    </div>
                    <div class="contenedor-peligro--item">
                      <div class="contenedor-peligro--item__centrado">
                        <h6>Peor consecuencia:</h6>
                        <p>{{ item.peor_consecuencia }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- MOSTRAR MEDIDAS DE INTERVENCIÓN -->
              <div slot="medidas_intervencion" slot-scope="props">
                <div
                  v-for="(item, index) in props.row.lista_peligros"
                  :key="index.item"
                  class="contenedor-basico-tabla"
                >
                  <div class="contenedor-basico-botones">
                    <button
                      type="button"
                      class="btn btn-sm btn_general font-weight-bold"
                      :style="[
                        item.eliminacion != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_eliminacion(
                          item.id_matriz
                        )
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_eliminacion"
                    >
                      Eliminación
                    </button>

                    <button
                      type="button"
                      class="btn btn-sm btn_general font-weight-bold"
                      :style="[
                        item.sustitucion != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_sustitucion(
                          item.id_matriz
                        )
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_sustitucion"
                    >
                      Sustitución
                    </button>

                    <button
                      type="button"
                      class="btn btn-sm btn_general font-weight-bold"
                      :style="[
                        item.controles_ing != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_controles(item.id_matriz)
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_controles"
                    >
                      Controles de Ingeniería
                    </button>

                    <button
                      type="button"
                      class="btn btn-sm btn_general font-weight-bold"
                      :style="[
                        item.controles_admin != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_controles_admin(
                          item.id_matriz
                        )
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_controles_admin"
                    >
                      Controles Administrativos
                    </button>

                    <button
                      type="button"
                      class="btn btn-sm btn_general font-weight-bold"
                      :style="[
                        item.equipos != ''
                          ? {
                              backgroundColor: '#e8640c !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            }
                          : {
                              backgroundColor: '#2b4c9b !important',
                              textAlign: 'center !important',
                              color: '#ffffff !important',
                              width: '150px',
                              margin: '2.5px',
                            },
                      ]"
                      @click="
                        consultar_medidas_intervencion_equipos(item.id_matriz)
                      "
                      data-toggle="modal"
                      data-target="#modal_medidas_intervencion_equipos"
                    >
                      Elementos de Protección Personal
                    </button>
                  </div>
                </div>
              </div>
              <!-- OPCIONES -->
              <div slot="opciones" slot-scope="props">
                <div
                  v-for="(item, index) in props.row.lista_peligros"
                  :key="index.item"
                  class="contenedor-basico-tabla"
                >
                  <button
                    class="btn btn-block dropdown-toggle boton_12"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    :disabled="
                      $store.state.global_nuevo_peligro ||
                      $store.state.global_es_editar
                    "
                  ></button>
                  <ul class="dropdown-menu boton_13" role="menu">
                      <li>
                        <a
                          class="btn btn-block mi_boton pull-left boton_14"
                          @click="editar_peligro(item.id_matriz)"
                          >&nbsp;<b>Editar Peligro</b></a
                        >
                      </li>
                      <li>
                        <a
                          class="btn btn-block mi_boton pull-left boton_14"
                          @click="
                            nuevo_peligro(
                              props.row.id_proceso,
                              props.row.proceso_riesgo,
                              props.row.id_zona,
                              props.row.zona,
                              props.row.id_actividad,
                              props.row.actividad,
                              props.row.id_tareas,
                              props.row.tarea,
                              props.row.rutinario_peligro
                            )
                          "
                          >&nbsp;<b>Nuevo Peligro</b></a
                        >
                      </li>
                      <li>
                        <a
                          class="btn btn-block mi_boton pull-left boton_14"
                          @click="eliminar_peligro(item.id_matriz)"
                          >&nbsp;<b>Eliminar Peligro</b></a
                        >
                      </li>
                      <li>
                        <a
                          class="btn btn-block mi_boton pull-left boton_14"
                          @click="
                            eliminar_proceso(
                              props.row.id_proceso,
                              props.row.id_zona,
                              props.row.id_actividad,
                              props.row.id_tareas
                            )
                          "
                          >&nbsp;<b>Eliminar Proceso</b></a
                        >
                      </li>
                  </ul>
                </div>
              </div>
            </v-client-table>
            <!-- FIN TABLA -->
          </div>
          <!-- MODAL FUENTE -->
          <div
            class="modal fade"
            id="modal_controles_existentes_fuente"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="row justify-content-center">
                    <h3 class="letra-sm-modal mb-3"><b>Fuente</b></h3>
                    <div v-if="fuente_checked != ''" class="col-sm-12">
                      <p>{{ fuente_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL MEDIO -->
          <div
            class="modal fade"
            id="modal_controles_existentes_medio"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="row justify-content-center">
                    <h3 class="letra-sm-modal mb-3"><b>Medio</b></h3>
                    <div v-if="medio_checked != ''" class="col-sm-12">
                      <p>{{ medio_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL INDIVIDUO -->
          <div
            class="modal fade"
            id="modal_controles_existentes_individuo"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="row justify-content-center">
                    <h3 class="letra-sm-modal mb-3"><b>Individuo</b></h3>
                    <div v-if="individuo_checked != ''" class="col-sm-12">
                      <p>{{ individuo_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL EVALUACIÓN RIESGO -->
          <div class="container">
            <div
              class="modal fade"
              id="modal_evaluacion_riesgo"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-dialog-centered modal-xl"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h2 class="modal-title">Evaluacion Riesgo</h2>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body container-fluid">
                    <div class="row justify-content-center">
                      <h3>Probabilidad</h3>
                    </div>
                    <div class="row justify-content-center">
                      <!-- ND -->
                      <div class="col-md-4">
                        <label class="color_letra">Nivel de Deficiencia:</label>
                        <input
                          type="text"
                          class="form-control form-control-sm boton_texto"
                          v-model="c_nivel_eficiencia"
                          title="NIVEL DE DEFICIENCIA
                                                    10: Pel. con consec. muy signi.
                                                        o la eficacia del conjunto de
                                                        medidas es nula, o ambos.
                                                    6: Pel. con consec. o la eficacia
                                                        del conjunto de medidas es bajo,
                                                        o ambos.
                                                    2: Pel. con consec. poco signi.
                                                        o la eficacia del conjunto de
                                                        medidas es moderado."
                          disabled
                        />
                      </div>
                      <!-- NE -->
                      <div class="col-md-4">
                        <label class="color_letra">Nivel de Exposición:</label>
                        <input
                          type="text"
                          class="form-control form-control-sm boton_texto"
                          v-model="c_nivel_exposicion"
                          title="NIVEL DE EXPOSICIÓN
                                                        4: Continua-Sin interrupción o
                                                        varias veces con tiempo prolongado
                                                        durante la jornada.
                                                        3: Frecuente-Varias veces durante
                                                        la jornada por tiempos cortos.
                                                        2: Ocasional-Algunas vez durante 
                                                        la jornada y por un periodo de
                                                        tiempo corto.
                                                        1: Esporádica-De manera eventual."
                          disabled
                        />
                      </div>
                      <!-- NP -->
                      <div class="col-md-4">
                        <label class="color_letra"
                          >Nivel de Probabilidad:</label
                        >
                        <input
                          type="text"
                          v-model="c_nivel_probabilidad"
                          class="form-control form-control-sm boton_texto"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row justify-content-center">
                      <!-- INTERPRETACIÓN -->
                      <div class="col-md-4">
                        <br /><label class="color_letra"
                          >Interpretación del Nivel de Probabilidad:</label
                        >
                        <input
                          type="text"
                          v-model="c_interpretacion"
                          class="
                            form-control form-control-sm
                            btn_general
                            font-weight-bold
                          "
                          :style="class_btn_outline"
                          readonly
                          required
                        />
                      </div>

                      <!-- CONSECUENCIA -->
                      <div class="col-md-4">
                        <br /><label class="color_letra"
                          >Nivel de Consecuencia:</label
                        >
                        <input
                          type="text"
                          class="form-control form-control-sm boton_texto"
                          v-model="c_nivel_consecuencia"
                          title="NIVEL DE CONSECUENCIA
                                                    100: Muerte(s).
                                                    60: Lesiones o enfermedades graves
                                                        irreparables (incapacidad permanente,
                                                        parcial o invalidez.
                                                    25:Lesiones o enfermedades con
                                                        incapacidad laboral temporal.
                                                    10: Lesiones o enfermedades que
                                                        no requieren incapacidad."
                          disabled
                        />
                      </div>
                      <!-- NR -->
                      <div class="col-md-4">
                        <br /><label class="color_letra"
                          >Nivel de Riesgo (NR) e Intervención:</label
                        >
                        <input
                          type="text"
                          class="form-control form-control-sm boton_texto"
                          v-model="c_nivel_riesgo"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row justify-content-center">
                      <!-- INTERPRETACIÓN NR -->
                      <div class="col-md-5">
                        <br /><label class="color_letra"
                          >Interpretación del NR:</label
                        >
                        <input
                          type="text"
                          v-model="c_interpretacion_nr"
                          class="
                            form-control form-control-sm
                            btn_general
                            interpretacion-nr
                            font-weight-bold
                          "
                          readonly
                        />
                      </div>
                      <!-- VR -->
                      <div class="col-md-7">
                        <br /><b
                          ><label class="color_letra"
                            >VALORACIÓN DEL RIESGO</label
                          ></b
                        >&nbsp;&nbsp;
                        <label class="color_letra"
                          >Aceptabilidad del Riesgo:</label
                        >
                        <input
                          type="text"
                          class="btn btn-sm btn_general font-weight-bold"
                          v-model="c_aceptabilidad"
                          :style="class_btn_alerts"
                          readonly
                          required
                        />
                      </div>
                    </div>
                    <div class="row justify-content-center mt-4">
                      <button
                        class="btn btn-sm btn-form"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        CERRAR
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL ELIMINACIÓN -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_eliminacion"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="row justify-content-center">
                    <h3 class="letra-sm-modal mb-3"><b>Eliminación</b></h3>
                    <div v-if="cm_eliminacion_checked != ''" class="col-sm-12">
                      <p>{{ cm_eliminacion_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL SUSTITUCIÓN -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_sustitucion"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="row justify-content-center">
                    <h3 class="letra-sm-modal mb-3"><b>Sustitución</b></h3>
                    <div v-if="cm_sustitucion_checked != ''" class="col-sm-12">
                      <p>{{ cm_sustitucion_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL CONTROLES INGENIERÍA -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_controles"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="row justify-content-center">
                    <h3 class="letra-sm-modal mb-3">
                      <b>Controles de Ingeniería</b>
                    </h3>
                    <div v-if="cm_controles_checked != ''" class="col-sm-12">
                      <p>{{ cm_controles_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL CONTROLES ADMINISTRATIVOS -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_controles_admin"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="row justify-content-center">
                    <h3 class="letra-sm-modal mb-3">
                      <b>Controles Administrativos</b>
                    </h3>
                    <div
                      v-if="cm_controles_admin_checked != ''"
                      class="col-sm-12"
                    >
                      <p>{{ cm_controles_admin_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL ELIMINACIÓN -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_equipos"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="row justify-content-center">
                    <h4 class="letra-sm-modal mb-3">
                      <b>Elementos de Protección Personal</b>
                    </h4>
                    <div v-if="cm_equipos_checked != ''" class="col-sm-12">
                      <p>{{ cm_equipos_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL EVALUACIÓN RIESGO MÓVIL -->
          <div class="container">
            <div
              class="modal fade"
              id="modal_evaluacion_riesgo_movil"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                class="
                  modal-dialog modal-dialog-centered modal-dialog-scrollable
                "
                role="document"
              >
                <div class="modal-content v-movil-divs">
                  <div class="modal-header bg-light border-bottom-0">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div
                    class="
                      modal-body
                      container-fluid
                      body-modal-movil
                      bg-light
                      mt-0
                    "
                  >
                    <div
                      class="
                        row
                        justify-content-center
                        text-secondary
                        v-movil-divs
                        text-align-center
                        mt-0
                      "
                    >
                      <h3 class="font-weight-bold mb-0 mt-0">
                        Evaluacion Riesgo
                      </h3>
                      <h4>Probabilidad</h4>
                    </div>
                    <div class="text-center bg-white v-movil-divs">
                      <!-- ND -->
                      <label class="text-dark"
                        >Nivel de Deficiencia:
                        <b class="color-respuestas">{{
                          c_nivel_eficiencia
                        }}</b></label
                      >
                      <br />
                      <label class="text-dark"
                        >Nivel de Exposición:
                        <b class="color-respuestas">{{
                          c_nivel_exposicion
                        }}</b></label
                      >
                      <br />
                      <label class="text-dark"
                        >Nivel de Probabilidad:
                        <b class="color-respuestas">{{
                          c_nivel_probabilidad
                        }}</b></label
                      >
                    </div>

                    <div class="text-center bg-light">
                      <!-- INTERPRETACIÓN -->
                      <div class="col-md-4">
                        <br /><label :style="class_btn_outline_m"
                          >Interpretación del Nivel de Probabilidad:</label
                        >
                        <p
                          class="font-weight-bold"
                          :style="class_btn_outline_m"
                        >
                          {{ c_interpretacion }}
                        </p>
                      </div>
                    </div>

                    <div class="text-center bg-white v-movil-divs">
                      <label class="text-dark"
                        >Nivel de Consecuencia:
                        <b class="color-respuestas">{{
                          c_nivel_consecuencia
                        }}</b></label
                      >

                      <label class="text-dark"
                        >Nivel de Riesgo (NR) e Intervención:
                        <b class="color-respuestas">{{
                          c_nivel_riesgo
                        }}</b></label
                      >
                    </div>

                    <div class="text-center">
                      <!-- INTERPRETACIÓN NR -->
                      <div class="col-md-5">
                        <br /><label class="text-primary"
                          >Interpretación del NR:</label
                        >
                        <p class="text-primary">{{ c_interpretacion_nr }}</p>
                      </div>
                      <!-- VR -->
                      <div class="text-center col-md-12">
                        <b class="mb-0"
                          ><label :style="class_btn_alerts_m"
                            >VALORACIÓN DEL RIESGO</label
                          ></b
                        >
                        <label :style="class_btn_alerts_m"
                          >Aceptabilidad del Riesgo:</label
                        >
                        <p class="font-weight-bold" :style="class_btn_alerts_m">
                          {{ c_aceptabilidad }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL FUENTE MÓVIL-->
          <div
            class="modal fade"
            id="modal_controles_existentes_fuente_movil"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              class="
                modal-dialog
                modal-dialog-centered
                modal-dialog-scrollable
                modal-sm
              "
              role="document"
            >
              <div class="modal-content bg-dark">
                <div class="modal-header border-bottom-0">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="text-white">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-white bg-dark body-modal-movil">
                  <div class="row justify-content-center">
                    <div v-if="fuente_checked != ''" class="col-sm-12">
                      <p>{{ fuente_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL MEDIO MÓVIL-->
          <div
            class="modal fade"
            id="modal_controles_existentes_medio_movil"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              class="
                modal-dialog
                modal-dialog-centered
                modal-dialog-scrollable
                modal-sm
              "
              role="document"
            >
              <div class="modal-content bg-dark">
                <div class="modal-header border-bottom-0">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="text-white">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-white bg-dark body-modal-movil">
                  <div class="row justify-content-center">
                    <div v-if="medio_checked != ''" class="col-sm-12">
                      <p>{{ medio_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL INDIVIDUO MÓVIL-->
          <div
            class="modal fade"
            id="modal_controles_existentes_individuo_movil"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              class="
                modal-dialog
                modal-dialog-centered
                modal-dialog-scrollable
                modal-sm
              "
              role="document"
            >
              <div class="modal-content bg-dark">
                <div class="modal-header border-bottom-0">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="text-white">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-white bg-dark body-modal-movil">
                  <div class="row justify-content-center">
                    <div v-if="individuo_checked != ''" class="col-sm-12">
                      <p>{{ individuo_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL ELIMINACIÓN MÓVIL -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_eliminacion_movil"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              class="
                modal-dialog
                modal-dialog-centered
                modal-dialog-scrollable
                modal-sm
              "
              role="document"
            >
              <div class="modal-content bg-dark">
                <div class="modal-header border-bottom-0">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="text-white">&times;</span>
                  </button>
                </div>
                <div class="modal-body bg-dark body-modal-movil">
                  <div class="row justify-content-center text-white">
                    <div v-if="cm_eliminacion_checked != ''" class="col-sm-12">
                      <p>{{ cm_eliminacion_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL SUSTITUCIÓN MÓVIL -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_sustitucion_movil"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              class="
                modal-dialog
                modal-dialog-centered
                modal-dialog-scrollable
                modal-sm
              "
              role="document"
            >
              <div class="modal-content bg-dark">
                <div class="modal-header border-bottom-0">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="text-white">&times;</span>
                  </button>
                </div>
                <div class="modal-body bg-dark body-modal-movil">
                  <div class="row justify-content-center text-white">
                    <div v-if="cm_sustitucion_checked != ''" class="col-sm-12">
                      <p>{{ cm_sustitucion_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL CONTROLES ING MÓVIL -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_controles_movil"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              class="
                modal-dialog
                modal-dialog-centered
                modal-dialog-scrollable
                modal-sm
              "
              role="document"
            >
              <div class="modal-content bg-dark">
                <div class="modal-header border-bottom-0">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="text-white">&times;</span>
                  </button>
                </div>
                <div class="modal-body bg-dark">
                  <div
                    class="
                      row
                      justify-content-center
                      text-white
                      body-modal-movil
                    "
                  >
                    <div v-if="cm_controles_checked != ''" class="col-sm-12">
                      <p>{{ cm_controles_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL CONTROLES ADMIN MÓVIL -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_controles_admin_movil"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
              role="document"
            >
              <div class="modal-content bg-dark">
                <div class="modal-header border-bottom-0">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="text-white">&times;</span>
                  </button>
                </div>
                <div class="modal-body bg-dark body-modal-movil">
                  <div class="row justify-content-center text-white">
                    <div
                      v-if="cm_controles_admin_checked != ''"
                      class="col-sm-12"
                    >
                      <p>{{ cm_controles_admin_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- MODAL ELIMINACION MÓVIL -->
          <div
            class="modal fade"
            id="modal_medidas_intervencion_equipos_movil"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
              role="document"
            >
              <div class="modal-content bg-dark">
                <div class="modal-header border-bottom-0">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="text-white">&times;</span>
                  </button>
                </div>
                <div class="modal-body bg-dark body-modal-movil">
                  <div class="row justify-content-center text-white">
                    <div v-if="cm_equipos_checked != ''" class="col-sm-12">
                      <p>{{ cm_equipos_checked }}</p>
                    </div>
                    <div v-else class="col-sm-12">
                      <p>Sin datos.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "./../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "mtm",
  data() {
    return {
      // CONTROLES EXISTENTES
      fuente_checked: [],
      medio_checked: [],
      individuo_checked: [],

      // MEDIDAS DE INTERVENCIÓN
      cm_eliminacion: [],
      cm_eliminacion_checked: [],
      cm_sustitucion: [],
      cm_sustitucion_checked: [],
      cm_controles: [],
      cm_controles_checked: [],
      cm_controles_admin: [],
      cm_controles_admin_checked: [],
      cm_equipos: [],
      cm_equipos_checked: [],

      otro_elim: "",
      otro_sus: "",
      otro_c_ing: "",
      otro_senal: "",
      otro_epp: "",

      // TABLA MATRIZ DE RIESGO
      columns: [
        "proceso_riesgo",
        "peligro",
        "e_efecto_posible",
        "controles_existentes",
        "evaluacion_riesgo",
        "criterios_controles",
        "medidas_intervencion",
        "opciones",
      ],
      options: {
        headings: {
          proceso_riesgo: "Proceso",
          peligro: "Peligro",
          e_efecto_posible: "Efectos Posibles",
          controles_existentes: "Controles Existentes",
          evaluacion_riesgo: "Evaluacion del Riesgo",
          criterios_controles: "Criterios Controles",
          medidas_intervencion: "Medidas Intervención",
          opciones: "Opciones",
        },
        sortable: ["proceso_riesgo", "zona", "actividad", "tarea"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: " ",
        },
      },

      columnsMovil: ["procesoMovil"],
      optionsMovil: {
        headings: {
          procesoMovil: "",
        },
        sortable: ["procesoMovil"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
        filterAlgorithm: {
          movil(row, query) {
            return (
              row.proceso_riesgo +
              " " +
              row.peligro +
              " " +
              row.e_efecto_posible +
              " " +
              row.controles_existentes +
              " " +
              row.evaluacion_riesgo +
              " " +
              row.criterios_controles +
              " " +
              row.medidas_intervencion
            ).includes(query);
          },
        },
        skin: "table table-condensed",
      },

      // EVALUACIÓN DEL RIESGO
      c_nivel_eficiencia: null,
      c_nivel_consecuencia: null,
      c_nivel_exposicion: null,
      c_nivel_probabilidad: null,
      c_interpretacion: null,

      c_nivel_riesgo: null,
      c_interpretacion_nr: null,
      c_aceptabilidad: null,

      class_btn_alerts: {
        border: "",
        textAlign: "center",
        color: "",
        width: "100%",
      },
      class_btn_alerts_m: {
        border: "",
        textAlign: "center",
        color: "",
        width: "100%",
      },
      class_btn_alerts_movil: {
        border: "",
        textAlign: "center",
        color: "",
        width: "70%",
      },
      class_btn_outline: {
        border: "",
        textAlign: "center",
        color: "",
      },
      class_btn_outline_m: {
        border: "",
        textAlign: "center",
        color: "",
      },

      // IDS LOCALES
      local_id_matriz_riesgo: "",

      // CRITERIOS CONTROLES
      c_num_expuestos: 0,
      c_peor_consecuencia: "",

      // VARIABLES PARA LA VERSIÓN MÓVIL
      lista_peligros_movil: [],
      id_matriz_movil: "",
      id_peligro_movil: "",
      clasificacion_movil: "",
      id_subcla_movil: "",
      subclasificacion_movil: "",
      descripcion_movil: "",
      id_efectos_posibles_movil: "",
      efecto_posible_movil: "",
      fuente_movil: "",
      medio_movil: "",
      individuo_movil: "",
      antecedente_movil: "",
      class_btn_outline_movil: "",
      class_btn_alerts_movil: "",
      aceptabilidad_movil: "",
      num_expuestos_movil: "",
      peor_consecuencia_movil: "",
      requisito_legal_movil: "",
      eliminacion_movil: "",
      equipos_movil: "",
      sustitucion_movil: "",
      controles_ing_movil: "",
      controles_admin_movil: "",

      id_proceso_movil: "",
      id_zona_movil: "",
      id_actividad_movil: "",
      id_tareas_movil: "",
      proceso_riesgo_movil: "",
      zona_movil: "",
      actividad_movil: "",
      tarea_movil: "",
      rutinario_peligro_movil: "",
    };
  },
  created() {
    if (!this.$store.state.global_llenar_matriz_peligros) {
      this.consultar_matriz_peligro_cliente();
      $(".carousel").carousel("pause");
    }
    EventBus.$on("cargar_tabla", () => {
      if (this.$store.state.global_llenar_matriz_peligros) {
        $(".carousel").carousel("pause");
        this.consultar_matriz_peligro_cliente();
        this.$store.state.global_llenar_matriz_peligros = false;
      }
    });
    $(".carousel").carousel("pause");
  },
  methods: {
    // LLENAR MATRIZ DE PELIGROS LOCAL
    async consultar_matriz_peligro_cliente() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (
        /windows phone/i.test(userAgent) ||
        /android/i.test(userAgent) ||
        (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
      ) {
        // VERSIÓN MÓVIL
        if (this.$store.state.global_matriz_peligro_cliente_movil.length > 0) {
        } else if (this.$store.state.msp_c_key) {
          NProgress.start();
          this.$store.state.global_matriz_peligro_cliente_movil = [];
          await db
            .collection("matriz_riesgo")
            .where("em_id_cliente", "==", this.$store.state.msp_c_key)
            .onSnapshot((snapshot) => {
              snapshot.docChanges().forEach((change) => {
                let rutinario = change.doc.data().em_rutinario;
                let class_btn_alerts = {
                  border: "",
                  textAlign: "center",
                  color: "",
                  width: "70%",
                };
                let class_btn_outline = {
                  border: "",
                  textAlign: "center",
                  color: "",
                };
                let em_aceptabilidad = "";
                let em_requisito_legal = change.doc.data().em_requisito_legal;
                if (em_requisito_legal == false) {
                  em_requisito_legal = "No";
                } else if (em_requisito_legal == true) {
                  em_requisito_legal = "Sí";
                }

                let em_eliminacion = [];
                let em_equipos = [];
                let em_sustitucion = [];
                let em_controles_ing = [];
                let em_controles_admin = [];
                let em_tarea = "";

                let array_efectos = [];
                if (
                  change.doc.data().em_efecto_posible == "" ||
                  change.doc.data().em_efecto_posible == "undefined" ||
                  change.doc.data().em_efecto_posible == undefined
                ) {
                  array_efectos = [];
                } else {
                  array_efectos = change.doc.data().em_efecto_posible;
                }
                const em_efecto_posible = array_efectos
                  .map((i) => ` ${i}`)
                  .toString();

                const array_tareas = change.doc.data().em_tarea;

                if (Array.isArray(array_tareas)) {
                  em_tarea = array_tareas.map((i) => ` ${i}`).toString();
                } else {
                  em_tarea = array_tareas;
                }

                const id_proceso = change.doc.data().em_id_proceso;

                if (rutinario == true) {
                  rutinario = "Sí";
                } else {
                  rutinario = "No";
                }
                em_aceptabilidad = change.doc.data().em_aceptabilidad;

                if (!em_aceptabilidad) {
                  em_aceptabilidad = "Pendiente";
                  class_btn_alerts.color = "#5bc0de";

                  class_btn_outline.color = "#5bc0de";
                } else {
                  if (change.doc.data().em_aceptabilidad == "No Aceptable") {
                    class_btn_alerts.color = "#d9534f";
                  } else if (
                    change.doc.data().em_aceptabilidad ==
                    "Aceptable con Control Específico"
                  ) {
                    class_btn_alerts.color = "#f0ad4e";
                  } else if (
                    change.doc.data().em_aceptabilidad == "Mejorable"
                  ) {
                    class_btn_alerts.color = "#5cb85c";
                  } else if (
                    change.doc.data().em_aceptabilidad == "Aceptable"
                  ) {
                    class_btn_alerts.color = "#5cb85c";
                  }

                  if (change.doc.data().c_interpretacion == "Muy alto") {
                    class_btn_outline.color = "#d9534f";
                  } else if (change.doc.data().em_interpretacion == "Alto") {
                    class_btn_outline.color = "#f0ad4e";
                  } else if (change.doc.data().em_interpretacion == "Medio") {
                    class_btn_outline.color = "#5cb85c";
                  } else if (change.doc.data().em_interpretacion == "Bajo") {
                    class_btn_outline.color = "#5cb85c";
                  }
                }

                if (change.doc.data().em_eliminacion) {
                  em_eliminacion = change.doc.data().em_eliminacion;
                }
                if (change.doc.data().em_sustitucion) {
                  em_sustitucion = change.doc.data().em_sustitucion;
                }
                if (change.doc.data().em_controles_ing) {
                  em_controles_ing = change.doc.data().em_controles_ing;
                } else if (change.doc.data().em_control_ingenieria) {
                  em_controles_ing = change.doc.data().em_control_ingenieria;
                }
                if (change.doc.data().em_controles) {
                  em_controles_admin = change.doc.data().em_controles;
                } else if (change.doc.data().em_controles_admin) {
                  em_controles_admin = change.doc.data().em_controles_admin;
                }
                if (change.doc.data().em_equipos) {
                  em_equipos = change.doc.data().em_equipos;
                } else if (change.doc.data().em_epp) {
                  em_equipos = change.doc.data().em_epp;
                }

                if (change.type === "added") {
                  if (
                    this.$store.state.global_matriz_peligro_cliente_movil
                      .length == 0
                  ) {
                    this.$store.state.global_matriz_peligro_cliente_movil.unshift(
                      {
                        id_cliente_iper: change.doc.data().em_id_cliente_iper,
                        id_cliente: change.doc.data().em_id_cliente,

                        id_proceso: change.doc.data().em_id_proceso,
                        id_zona: change.doc.data().em_id_zona,
                        id_actividad: change.doc.data().em_id_acti,
                        id_tareas: change.doc.data().em_id_tareas,

                        proceso_riesgo: change.doc.data().em_proceso,
                        zona: change.doc.data().em_zona,
                        actividad: change.doc.data().em_actividad,
                        tarea: em_tarea,
                        rutinario_peligro: rutinario,

                        lista_peligros: [
                          {
                            id_matriz: change.doc.id,
                            id_peligro: change.doc.data().em_id_peligro,
                            clasificacion: change.doc.data().em_clasificacion,
                            id_subcla: change.doc.data().em_id_subclasificacion,
                            subclasificacion: change.doc.data().em_tipo,
                            descripcion: change.doc.data().em_descripcion,

                            id_efectos_posibles:
                              change.doc.data().em_id_efectos_posibles,
                            efecto_posible: em_efecto_posible,

                            fuente: change.doc.data().em_c_fuente,
                            medio: change.doc.data().em_c_medio,
                            individuo: change.doc.data().em_c_individuo,
                            antecedente: change.doc.data().em_antecedente,
                            class_btn_outline: class_btn_outline,
                            class_btn_alerts: class_btn_alerts,
                            aceptabilidad: em_aceptabilidad,

                            num_expuestos: change.doc.data().em_num_expuestos,
                            peor_consecuencia:
                              change.doc.data().em_peor_consecuencia,
                            requisito_legal: em_requisito_legal,

                            eliminacion: em_eliminacion,
                            equipos: em_equipos,
                            sustitucion: em_sustitucion,
                            controles_ing: em_controles_ing,
                            controles_admin: em_controles_admin,
                          },
                        ],
                      }
                    );
                  } else {
                    let es_peligro = false;
                    this.$store.state.global_matriz_peligro_cliente_movil.forEach(
                      (i) => {
                        if (i.id_proceso == id_proceso) {
                          es_peligro = true;
                          i.lista_peligros.unshift({
                            id_matriz: change.doc.id,
                            id_peligro: change.doc.data().em_id_peligro,
                            clasificacion: change.doc.data().em_clasificacion,
                            id_subcla: change.doc.data().em_id_subclasificacion,
                            subclasificacion: change.doc.data().em_tipo,
                            descripcion: change.doc.data().em_descripcion,

                            id_efectos_posibles:
                              change.doc.data().em_id_efectos_posibles,
                            efecto_posible: em_efecto_posible,

                            fuente: change.doc.data().em_c_fuente,
                            medio: change.doc.data().em_c_medio,
                            individuo: change.doc.data().em_c_individuo,
                            antecedente: change.doc.data().em_antecedente,
                            class_btn_outline: class_btn_outline,
                            class_btn_alerts: class_btn_alerts,
                            aceptabilidad: em_aceptabilidad,

                            num_expuestos: change.doc.data().em_num_expuestos,
                            peor_consecuencia:
                              change.doc.data().em_peor_consecuencia,
                            requisito_legal: em_requisito_legal,

                            eliminacion: em_eliminacion,
                            equipos: em_equipos,
                            sustitucion: em_sustitucion,
                            controles_ing: em_controles_ing,
                            controles_admin: em_controles_admin,
                          });
                        }
                      }
                    );
                    if (!es_peligro) {
                      this.$store.state.global_matriz_peligro_cliente_movil.unshift(
                        {
                          id_cliente_iper: change.doc.data().em_id_cliente_iper,
                          id_cliente: change.doc.data().em_id_cliente,

                          id_proceso: change.doc.data().em_id_proceso,
                          id_zona: change.doc.data().em_id_zona,
                          id_actividad: change.doc.data().em_id_acti,
                          id_tareas: change.doc.data().em_id_tareas,

                          proceso_riesgo: change.doc.data().em_proceso,
                          zona: change.doc.data().em_zona,
                          actividad: change.doc.data().em_actividad,
                          tarea: em_tarea,
                          rutinario_peligro: rutinario,

                          lista_peligros: [
                            {
                              id_matriz: change.doc.id,
                              id_peligro: change.doc.data().em_id_peligro,
                              clasificacion: change.doc.data().em_clasificacion,
                              id_subcla:
                                change.doc.data().em_id_subclasificacion,
                              subclasificacion: change.doc.data().em_tipo,
                              descripcion: change.doc.data().em_descripcion,

                              id_efectos_posibles:
                                change.doc.data().em_id_efectos_posibles,
                              efecto_posible: em_efecto_posible,

                              fuente: change.doc.data().em_c_fuente,
                              medio: change.doc.data().em_c_medio,
                              individuo: change.doc.data().em_c_individuo,
                              antecedente: change.doc.data().em_antecedente,
                              class_btn_outline: class_btn_outline,
                              class_btn_alerts: class_btn_alerts,
                              aceptabilidad: em_aceptabilidad,

                              num_expuestos: change.doc.data().em_num_expuestos,
                              peor_consecuencia:
                                change.doc.data().em_peor_consecuencia,
                              requisito_legal: em_requisito_legal,

                              eliminacion: em_eliminacion,
                              equipos: em_equipos,
                              sustitucion: em_sustitucion,
                              controles_ing: em_controles_ing,
                              controles_admin: em_controles_admin,
                            },
                          ],
                        }
                      );
                    }
                  }
                } else if (change.type === "modified") {
                  for (
                    let item = 0;
                    item <
                    this.$store.state.global_matriz_peligro_cliente_movil
                      .length;
                    item++
                  ) {
                    if (
                      this.$store.state.global_matriz_peligro_cliente_movil[
                        item
                      ].id_proceso == id_proceso
                    ) {
                      this.$store.state.global_matriz_peligro_cliente_movil[
                        item
                      ].proceso_riesgo = change.doc.data().em_proceso;
                      this.$store.state.global_matriz_peligro_cliente_movil[
                        item
                      ].zona = change.doc.data().em_zona;
                      this.$store.state.global_matriz_peligro_cliente_movil[
                        item
                      ].actividad = change.doc.data().em_actividad;
                      this.$store.state.global_matriz_peligro_cliente_movil[
                        item
                      ].tarea = em_tarea;
                      this.$store.state.global_matriz_peligro_cliente_movil[
                        item
                      ].rutinario_peligro = rutinario;

                      this.$store.state.global_matriz_peligro_cliente_movil[
                        item
                      ].lista_peligros.forEach((i) => {
                        if (i.id_matriz == change.doc.id) {
                          i.id_peligro = change.doc.data().em_id_peligro;
                          i.clasificacion = change.doc.data().em_clasificacion;
                          i.id_subcla =
                            change.doc.data().em_id_subclasificacion;
                          i.subclasificacion = change.doc.data().em_tipo;
                          i.descripcion = change.doc.data().em_descripcion;

                          i.id_efectos_posibles =
                            change.doc.data().em_id_efectos_posibles;
                          i.efecto_posible = em_efecto_posible;

                          i.fuente = change.doc.data().em_c_fuente;
                          i.medio = change.doc.data().em_c_medio;
                          i.individuo = change.doc.data().em_c_individuo;
                          i.antecedente = change.doc.data().em_antecedente;
                          i.class_btn_outline = class_btn_outline;
                          (i.class_btn_alerts = class_btn_alerts),
                            (i.aceptabilidad = em_aceptabilidad),
                            (i.num_expuestos =
                              change.doc.data().em_num_expuestos);
                          i.peor_consecuencia =
                            change.doc.data().em_peor_consecuencia;
                          i.requisito_legal = em_requisito_legal;

                          i.eliminacion = em_eliminacion;
                          i.sustitucion = em_sustitucion;
                          i.controles_ing = em_controles_ing;
                          i.controles_admin = em_controles_admin;
                          i.equipos = em_equipos;
                        }
                      });
                    }
                  }
                } else if (change.type === "removed") {
                  this.$store.state.global_matriz_peligro_cliente_movil.forEach(
                    (i, index) => {
                      if (i.id_tareas == change.doc.data().em_id_tareas) {
                        i.lista_peligros.forEach((e, jndex) => {
                          if (e.id_matriz == `${change.doc.id}`) {
                            i.lista_peligros.splice(jndex, 1);
                            if (i.lista_peligros.length == 0) {
                              this.$store.state.global_matriz_peligro_cliente_movil.splice(
                                index,
                                1
                              );
                            }
                          }
                        });
                      }
                    }
                  );
                }
                /* let set = new Set(
                  this.$store.state.global_matriz_peligro_cliente_movil.map(
                    JSON.stringify
                  )
                );
                this.$store.state.global_matriz_peligro_cliente_movil = Array.from(
                  set
                ).map(JSON.parse); */
              });
            });
          NProgress.done();
          NProgress.remove();
        }
      } else {
        // VERSIÓN PC
        if (this.$store.state.global_matriz_peligro_cliente.length != 0) {
        } else if (this.$store.state.msp_c_key) {
          NProgress.start();
          this.$store.state.global_matriz_peligro_cliente = [];
          await db
            .collection("matriz_riesgo")
            .where("em_id_cliente", "==", this.$store.state.msp_c_key)
            .onSnapshot((snapshot) => {
              snapshot.docChanges().forEach((change) => {
                let rutinario = change.doc.data().em_rutinario;
                let class_btn_alerts = {
                  border: "",
                  textAlign: "center",
                  color: "",
                  width: "100%",
                };
                let class_btn_outline = {
                  border: "",
                  textAlign: "center",
                  color: "",
                };
                let em_aceptabilidad = "";
                let em_requisito_legal = change.doc.data().em_requisito_legal;
                if (em_requisito_legal == false) {
                  em_requisito_legal = "No";
                } else if (em_requisito_legal == true) {
                  em_requisito_legal = "Sí";
                }

                let em_eliminacion = [];
                let em_sustitucion = [];
                let em_controles_ing = [];
                let em_controles_admin = [];
                let em_equipos = [];
                let em_tarea = "";

                let array_efectos = [];
                if (
                  change.doc.data().em_efecto_posible == "" ||
                  change.doc.data().em_efecto_posible == "undefined" ||
                  change.doc.data().em_efecto_posible == undefined
                ) {
                  array_efectos = [];
                } else {
                  array_efectos = change.doc.data().em_efecto_posible;
                }
                const em_efecto_posible = array_efectos
                  .map((i) => ` ${i}`)
                  .toString();

                const array_tareas = change.doc.data().em_tarea;

                if (Array.isArray(array_tareas)) {
                  em_tarea = array_tareas.map((i) => ` ${i}`).toString();
                } else {
                  em_tarea = array_tareas;
                }

                const id_proceso = change.doc.data().em_id_proceso;

                if (rutinario == true) {
                  rutinario = "Sí";
                } else {
                  rutinario = "No";
                }
                em_aceptabilidad = change.doc.data().em_aceptabilidad;

                if (!em_aceptabilidad) {
                  em_aceptabilidad = "Pendiente";
                  class_btn_alerts.border = "3px solid #5bc0de";
                  class_btn_alerts.color = "#5bc0de";

                  class_btn_outline.border = "3px solid #5bc0de";
                  class_btn_outline.color = "#5bc0de";
                } else {
                  if (change.doc.data().em_aceptabilidad == "No Aceptable") {
                    class_btn_alerts.border = "3px solid #d9534f";
                    class_btn_alerts.color = "#d9534f";
                  } else if (
                    change.doc.data().em_aceptabilidad ==
                    "Aceptable con Control Específico"
                  ) {
                    class_btn_alerts.border = "3px solid #f0ad4e";
                    class_btn_alerts.color = "#f0ad4e";
                  } else if (
                    change.doc.data().em_aceptabilidad == "Mejorable"
                  ) {
                    class_btn_alerts.border = "3px solid #5cb85c";
                    class_btn_alerts.color = "#5cb85c";
                  } else if (
                    change.doc.data().em_aceptabilidad == "Aceptable"
                  ) {
                    class_btn_alerts.border = "3px solid #5cb85c";
                    class_btn_alerts.color = "#5cb85c";
                  }

                  if (change.doc.data().c_interpretacion == "Muy alto") {
                    class_btn_outline.border = "3px solid #d9534f";
                    class_btn_outline.color = "#d9534f";
                  } else if (change.doc.data().em_interpretacion == "Alto") {
                    class_btn_outline.border = "3px solid #f0ad4e";
                    class_btn_outline.color = "#f0ad4e";
                  } else if (change.doc.data().em_interpretacion == "Medio") {
                    class_btn_outline.border = "3px solid #5cb85c";
                    class_btn_outline.color = "#5cb85c";
                  } else if (change.doc.data().em_interpretacion == "Bajo") {
                    class_btn_outline.border = "3px solid #5cb85c";
                    class_btn_outline.color = "#5cb85c";
                  }
                }

                if (change.doc.data().em_eliminacion) {
                  em_eliminacion = change.doc.data().em_eliminacion;
                }
                if (change.doc.data().em_sustitucion) {
                  em_sustitucion = change.doc.data().em_sustitucion;
                }
                if (change.doc.data().em_controles_ing) {
                  em_controles_ing = change.doc.data().em_controles_ing;
                } else if (change.doc.data().em_control_ingenieria) {
                  em_controles_ing = change.doc.data().em_control_ingenieria;
                }
                if (change.doc.data().em_controles) {
                  em_controles_admin = change.doc.data().em_controles;
                } else if (change.doc.data().em_controles_admin) {
                  em_controles_admin = change.doc.data().em_controles_admin;
                }
                if (change.doc.data().em_equipos) {
                  em_equipos = change.doc.data().em_equipos;
                } else if (change.doc.data().em_epp) {
                  em_equipos = change.doc.data().em_epp;
                }

                if (change.type === "added") {
                  this.$store.state.global_matriz_peligro_cliente.unshift({
                    id_cliente_iper: change.doc.data().em_id_cliente_iper,
                    id_cliente: change.doc.data().em_id_cliente,

                    id_proceso: change.doc.data().em_id_proceso,
                    id_zona: change.doc.data().em_id_zona,
                    id_actividad: change.doc.data().em_id_acti,
                    id_tareas: change.doc.data().em_id_tareas,

                    proceso_riesgo: change.doc.data().em_proceso,
                    zona: change.doc.data().em_zona,
                    actividad: change.doc.data().em_actividad,
                    tarea: em_tarea,
                    rutinario_peligro: rutinario,

                    lista_peligros: [
                      {
                        id_matriz: change.doc.id,
                        id_peligro: change.doc.data().em_id_peligro,
                        clasificacion: change.doc.data().em_clasificacion,
                        id_subcla: change.doc.data().em_id_subclasificacion,
                        subclasificacion: change.doc.data().em_tipo,
                        descripcion: change.doc.data().em_descripcion,

                        id_efectos_posibles:
                          change.doc.data().em_id_efectos_posibles,
                        efecto_posible: em_efecto_posible,

                        fuente: change.doc.data().em_c_fuente,
                        medio: change.doc.data().em_c_medio,
                        individuo: change.doc.data().em_c_individuo,
                        antecedente: change.doc.data().em_antecedente,
                        class_btn_outline: class_btn_outline,
                        class_btn_alerts: class_btn_alerts,
                        aceptabilidad: em_aceptabilidad,

                        num_expuestos: change.doc.data().em_num_expuestos,
                        peor_consecuencia:
                          change.doc.data().em_peor_consecuencia,
                        requisito_legal: em_requisito_legal,

                        eliminacion: em_eliminacion,
                        sustitucion: em_sustitucion,
                        controles_ing: em_controles_ing,
                        controles_admin: em_controles_admin,
                        equipos: em_equipos,
                      },
                    ],
                  });
                  let set = new Set(
                    this.$store.state.global_matriz_peligro_cliente.map(
                      JSON.stringify
                    )
                  );
                  this.$store.state.global_matriz_peligro_cliente = Array.from(
                    set
                  ).map(JSON.parse);
                } else if (change.type === "modified") {
                  for (
                    let item = 0;
                    item <
                    this.$store.state.global_matriz_peligro_cliente.length;
                    item++
                  ) {
                    if (
                      this.$store.state.global_matriz_peligro_cliente[item]
                        .id_proceso == id_proceso
                    ) {
                      this.$store.state.global_matriz_peligro_cliente[
                        item
                      ].proceso_riesgo = change.doc.data().em_proceso;
                      this.$store.state.global_matriz_peligro_cliente[
                        item
                      ].zona = change.doc.data().em_zona;
                      this.$store.state.global_matriz_peligro_cliente[
                        item
                      ].actividad = change.doc.data().em_actividad;
                      this.$store.state.global_matriz_peligro_cliente[
                        item
                      ].tarea = em_tarea;
                      this.$store.state.global_matriz_peligro_cliente[
                        item
                      ].rutinario_peligro = rutinario;

                      this.$store.state.global_matriz_peligro_cliente[
                        item
                      ].lista_peligros.forEach((i) => {
                        if (i.id_matriz == change.doc.id) {
                          i.id_peligro = change.doc.data().em_id_peligro;
                          i.clasificacion = change.doc.data().em_clasificacion;
                          i.id_subcla =
                            change.doc.data().em_id_subclasificacion;
                          i.subclasificacion = change.doc.data().em_tipo;
                          i.descripcion = change.doc.data().em_descripcion;

                          i.id_efectos_posibles =
                            change.doc.data().em_id_efectos_posibles;
                          i.efecto_posible = em_efecto_posible;

                          i.fuente = change.doc.data().em_c_fuente;
                          i.medio = change.doc.data().em_c_medio;
                          i.individuo = change.doc.data().em_c_individuo;
                          i.antecedente = change.doc.data().em_antecedente;
                          i.class_btn_outline = class_btn_outline;
                          (i.class_btn_alerts = class_btn_alerts),
                            (i.aceptabilidad = em_aceptabilidad),
                            (i.num_expuestos =
                              change.doc.data().em_num_expuestos);
                          i.peor_consecuencia =
                            change.doc.data().em_peor_consecuencia;
                          i.requisito_legal = em_requisito_legal;

                          i.eliminacion = em_eliminacion;
                          i.sustitucion = em_sustitucion;
                          i.controles_ing = em_controles_ing;
                          i.controles_admin = em_controles_admin;
                          i.equipos = em_equipos;
                        }
                      });
                    }
                  }
                } else if (change.type === "removed") {
                  this.$store.state.global_matriz_peligro_cliente.forEach(
                    (i, index) => {
                      if (i.id_tareas == change.doc.data().em_id_tareas) {
                        i.lista_peligros.forEach((e, jndex) => {
                          if (e.id_matriz == `${change.doc.id}`) {
                            i.lista_peligros.splice(jndex, 1);
                            if (i.lista_peligros.length == 0) {
                              this.$store.state.global_matriz_peligro_cliente.splice(
                                index,
                                1
                              );
                            }
                          }
                        });
                      }
                    }
                  );
                }
                let set = new Set(
                  this.$store.state.global_matriz_peligro_cliente.map(
                    JSON.stringify
                  )
                );
                this.$store.state.global_matriz_peligro_cliente = Array.from(
                  set
                ).map(JSON.parse);
              });
            });
          NProgress.done();
          NProgress.remove();
        }
      }
    },

    async mostrar_controles_fuente(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.fuente_checked = [];
      let fuente = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LAS FUENTES CHECKEADAS
          fuente = doc.data().em_c_fuente;
        }
      });

      if (Array.isArray(fuente)) {
        this.fuente_checked = fuente.map((i) => ` ${i}`).toString();
      } else {
        this.fuente_checked = fuente;
      }
      NProgress.done();
      NProgress.remove();
    },

    async mostrar_controles_medio(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.medio_checked = [];
      let medio = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LOS MEDIOS CHECKEADOS
          medio = doc.data().em_c_medio;
        }
      });
      if (Array.isArray(medio)) {
        this.medio_checked = medio.map((i) => ` ${i}`).toString();
      } else {
        this.medio_checked = medio;
      }
      NProgress.done();
      NProgress.remove();
    },

    async mostrar_controles_individuo(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.individuo_checked = [];
      let individuo = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LOS INDIVIDUOS CHECKEADOS
          individuo = doc.data().em_c_individuo;
        }
      });
      if (Array.isArray(individuo)) {
        this.individuo_checked = individuo.map((i) => ` ${i}`).toString();
      } else {
        this.individuo_checked = individuo;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_evaluacion_riesgo(
      id_matriz,
      class_btn_outline,
      class_btn_alerts
    ) {
      this.limpiar_variables();
      NProgress.start();
      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef
        .get()
        .then((doc) => {
          this.c_aceptabilidad = doc.data().em_aceptabilidad;
          if (this.c_aceptabilidad == "" || this.c_aceptabilidad == null) {
            this.c_aceptabilidad = "Pendiente";
            this.c_interpretacion = "Pendiente";
            this.c_interpretacion_nr = "Pendiente";

            this.c_nivel_eficiencia = null;
            this.c_nivel_exposicion = null;
            this.c_nivel_probabilidad = null;
            this.c_nivel_consecuencia = null;
            this.c_nivel_riesgo = null;
          } else {
            this.c_nivel_eficiencia = doc.data().em_nivel_eficiencia;
            this.c_nivel_exposicion = doc.data().em_nivel_exposicion;
            this.c_nivel_probabilidad = doc.data().em_nivel_probabilidad;
            this.c_nivel_consecuencia = doc.data().em_nivel_consecuencia;
            this.c_nivel_riesgo = doc.data().em_nivel_riesgo;
            this.c_interpretacion = doc.data().em_interpretacion;
            this.c_interpretacion_nr = doc.data().em_interpretacion_nr;
          }
          this.class_btn_outline = class_btn_outline;
          this.class_btn_alerts = class_btn_alerts;

          this.local_id_matriz_riesgo = id_matriz;
          $("#modal_evaluacion_riesgo").modal("show");
        })
        .catch((error) => {
          console.log(
            "Error al obtener la evaluación de riesgos de matriz_riesgos",
            error
          );
        });
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_eliminacion(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_eliminacion_checked = [];
      let eliminacion = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LA ELIMINACIÓN CHECKEADA
          eliminacion = doc.data().em_eliminacion;
        }
      });
      if (Array.isArray(eliminacion)) {
        this.cm_eliminacion_checked = eliminacion
          .map((i) => ` ${i}`)
          .toString();
      } else {
        this.cm_eliminacion_checked = eliminacion;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_sustitucion(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_sustitucion_checked = [];
      let sustitucion = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          // ARRAY CON LA SUSTITUCIÓN CHECKEADA
          sustitucion = doc.data().em_sustitucion;
        }
      });
      if (Array.isArray(sustitucion)) {
        this.cm_sustitucion_checked = sustitucion
          .map((i) => ` ${i}`)
          .toString();
      } else {
        this.cm_sustitucion_checked = sustitucion;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_controles(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_controles_checked = [];
      let controles = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          if (doc.data().em_controles_ing) {
            // ARRAY CON LOS CONTROLES CHECKEADOS
            controles = doc.data().em_controles_ing;
          } else if (doc.data().em_control_ingenieria) {
            controles = doc.data().em_control_ingenieria;
          }
        }
      });
      if (Array.isArray(controles)) {
        this.cm_controles_checked = controles.map((i) => ` ${i}`).toString();
      } else {
        this.cm_controles_checked = controles;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_controles_admin(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_controles_admin_checked = [];
      let controles_admin = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          if (doc.data().em_controles) {
            // ARRAY CON LOS CONTROLES ADMINISTRATIVOS CHECKEADOS
            controles_admin = doc.data().em_controles;
          } else if (doc.data().em_controles_admin) {
            controles_admin = doc.data().em_controles_admin;
          }
        }
      });
      if (Array.isArray(controles_admin)) {
        this.cm_controles_admin_checked = controles_admin
          .map((i) => ` ${i}`)
          .toString();
      } else {
        this.cm_controles_admin_checked = controles_admin;
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultar_medidas_intervencion_equipos(id_matriz) {
      NProgress.start();
      this.local_id_matriz_riesgo = id_matriz;
      this.cm_equipos_checked = [];
      let equipos = "";

      const docRef = db.collection("matriz_riesgo").doc(id_matriz);
      await docRef.get().then((doc) => {
        if (doc.exists) {
          if (doc.data().em_equipos) {
            // ARRAY CON LOS EQUIPOS CHECKEADOS
            equipos = doc.data().em_equipos;
          } else if (doc.data().em_epp) {
            equipos = doc.data().em_epp;
          }
        }
      });
      if (Array.isArray(equipos)) {
        this.cm_equipos_checked = equipos.map((i) => ` ${i}`).toString();
      } else {
        this.cm_equipos_checked = equipos;
      }
      NProgress.done();
      NProgress.remove();
    },

    // ELIMINAR PELIGRO MATRIZ PELIGRO
    eliminar_peligro(id_matriz) {
      Swal.fire({
        icon: "warning",
        title:
          "<h4 style='color: white'>¿Estás seguro de eliminar el peligro?</h4>",
        html: "<h5 style='color: white'>¡Se eliminará el peligro permanentemente!</h5>",
        background: "transparent",
        backdrop: `rgba(0,0,0,0.8)`,
        confirmButtonColor: "transparent",
        cancelButtonColor: "transparent",
        confirmButtonText:
          "<span style='color: white; border-color: #5cb85c' class='btn btn_semaforo'>Eliminar</span>",
        cancelButtonText:
          "<span style='color: white; border-color: #FF3333' class='btn btn_semaforo'>Cancelar</span>",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          // ELIMINAR DE LA COLECCIÓN
          db.collection("matriz_riesgo").doc(id_matriz).delete();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            icon: "error",
            title: "<h4 style='color: white'>Operación Cancelada</h4>",
            timer: 2000,
            background: "transparent",
            backdrop: `rgba(0,0,0,0.8)`,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      });
    },

    // ELIMINAR PROCESO MATRIZ PELIGRO
    eliminar_proceso(id_proceso, id_zona, id_actividad, id_tareas) {
      Swal.fire({
        icon: "warning",
        title:
          "<h4 style='color: white'>¿Estás seguro de eliminar el proceso?</h4>",
        html: "<h5 style='color: white'>¡Se eliminarán todos los peligros asociados a este proceso permanentemente!</h5>",
        background: "transparent",
        backdrop: `rgba(0,0,0,0.8)`,
        confirmButtonColor: "transparent",
        cancelButtonColor: "transparent",
        confirmButtonText:
          "<span style='color: white; border-color: #5cb85c' class='btn btn_semaforo'>Eliminar</span>",
        cancelButtonText:
          "<span style='color: white; border-color: #FF3333' class='btn btn_semaforo'>Cancelar</span>",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          db.collection("proceso").doc(id_proceso).delete();
          db.collection("zona").doc(id_zona).delete();
          db.collection("actividades").doc(id_actividad).delete();
          db.collection("tareas").doc(id_tareas).delete();

          this.$store.state.global_matriz_peligro_cliente.forEach((i) => {
            if (i.id_proceso == id_proceso) {
              i.lista_peligros.forEach((j) => {
                db.collection("matriz_riesgo").doc(j.id_matriz).delete();
              });
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            icon: "error",
            title: "<h4 style='color: white'>Operación Cancelada</h4>",
            timer: 2000,
            background: "transparent",
            backdrop: `rgba(0,0,0,0.8)`,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      });
    },

    async editar_peligro(id_matriz) {
      await this.$store.commit("mutation_preparacion_botones_tabla");
      this.$store.state.global_id_matriz_riesgo = id_matriz;
      this.$store.state.global_es_editar = true;

      const tap2 = document.getElementById("mip-tab");
      tap2.setAttribute("aria-selected", true);
      setTimeout(() => this.$router.push("/identificar_peligros"), 1000);
    },

    async nuevo_peligro(
      id_proceso,
      proceso_riesgo,
      id_zona,
      zona,
      id_actividad,
      actividad,
      id_tareas,
      tarea,
      rutinario_peligro
    ) {
      await this.$store.commit("mutation_preparacion_botones_tabla");

      this.$store.state.mip_id_proceso = id_proceso;
      this.$store.state.mip_id_zona = id_zona;
      this.$store.state.mip_id_actividad = id_actividad;
      this.$store.state.mip_id_tareas = id_tareas;

      this.$store.state.mip_proceso = proceso_riesgo;
      this.$store.state.mip_zona = zona;
      this.$store.state.mip_actividad = actividad;
      this.$store.state.mip_tarea = tarea;
      this.$store.state.mip_rutinario = rutinario_peligro;

      this.$store.state.global_id_matriz_riesgo = db
        .collection("matriz_riesgo")
        .doc().id;

      this.$store.state.global_nuevo_peligro = true;

      const tap2 = document.getElementById("mip-tab");
      tap2.setAttribute("aria-selected", true);
      this.$router.push("/identificar_peligros");
    },

    // LIMPIAR VARIABLES
    limpiar_variables() {
      this.local_id_matriz_riesgo = "";
      this.local_id_peligro = "";
      this.local_id_subcla = "";

      this.c_nivel_eficiencia = null;
      this.c_nivel_exposicion = null;
      this.c_nivel_probabilidad = 0;
      this.c_interpretacion = "";
      this.c_nivel_consecuencia = null;
      this.c_nivel_riesgo = 0;
      this.c_interpretacion_nr = 0;
      this.c_aceptabilidad = "";
      this.class_btn_alerts = {
        border: "",
        textAlign: "center",
        color: "",
      };
      this.class_btn_outline = {
        border: "",
        textAlign: "center",
        color: "",
      };

      this.c_num_expuestos = 0;
      this.c_peor_consecuencia = "";

      // LIMPIAR CONTROLES
      this.fuente_checked = [];
      this.medio_checked = [];
      this.individuo_checked = [];

      // LIMPIAR MEDIDAS DE INTERVENCIÓN
      this.cm_eliminacion = [];
      this.cm_eliminacion_checked = [];
      this.cm_sustitucion = [];
      this.cm_sustitucion_checked = [];
      this.cm_controles = [];
      this.cm_controles_checked = [];
      this.cm_controles_admin = [];
      this.cm_controles_admin_checked = [];
      this.cm_equipos = [];
      this.cm_equipos_checked = [];
    },

    query_peligro_vm(id_matriz) {
      let docRef = db.collection("matriz_riesgo").doc(id_matriz);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            let rutinario = doc.data().em_rutinario;
            let class_btn_alerts = {
              border: "",
              textAlign: "center",
              color: "",
              width: "70%",
            };
            let class_btn_alerts_m = {
              border: "",
              textAlign: "center",
              color: "",
            };
            let class_btn_outline = {
              border: "",
              textAlign: "center",
              color: "",
            };
            let class_btn_outline_m = {
              border: "",
              textAlign: "center",
              color: "",
            };
            let em_aceptabilidad = "";
            let em_requisito_legal = doc.data().em_requisito_legal;
            if (em_requisito_legal == false) {
              em_requisito_legal = "No";
            } else if (em_requisito_legal == true) {
              em_requisito_legal = "Sí";
            }

            let em_eliminacion = [];
            let em_equipos = [];
            let em_sustitucion = [];
            let em_controles_ing = [];
            let em_controles_admin = [];
            let em_tarea = "";

            const array_efectos = doc.data().em_efecto_posible;
            const em_efecto_posible = array_efectos
              .map((i) => ` ${i}`)
              .toString();

            const array_tareas = doc.data().em_tarea;

            if (Array.isArray(array_tareas)) {
              em_tarea = array_tareas.map((i) => ` ${i}`).toString();
            } else {
              em_tarea = array_tareas;
            }

            const id_proceso = doc.data().em_id_proceso;

            if (rutinario == true) {
              rutinario = "Sí";
            } else {
              rutinario = "No";
            }
            em_aceptabilidad = doc.data().em_aceptabilidad;

            if (!em_aceptabilidad) {
              em_aceptabilidad = "Pendiente";
              class_btn_alerts.border = "3px solid #5bc0de";
              class_btn_alerts.color = "#5bc0de";
              class_btn_alerts_m.color = "#5bc0de";

              class_btn_outline.border = "3px solid #5bc0de";
              class_btn_outline.color = "#5bc0de";
            } else {
              if (doc.data().em_aceptabilidad == "No Aceptable") {
                class_btn_alerts.border = "3px solid #d9534f";
                class_btn_alerts.color = "#d9534f";
                class_btn_alerts_m.color = "#d9534f";
              } else if (
                doc.data().em_aceptabilidad ==
                "Aceptable con Control Específico"
              ) {
                class_btn_alerts.border = "3px solid #f0ad4e";
                class_btn_alerts.color = "#f0ad4e";
                class_btn_alerts_m.color = "#f0ad4e";
              } else if (doc.data().em_aceptabilidad == "Mejorable") {
                class_btn_alerts.border = "3px solid #5cb85c";
                class_btn_alerts.color = "#5cb85c";
              } else if (doc.data().em_aceptabilidad == "Aceptable") {
                class_btn_alerts.border = "3px solid #5cb85c";
                class_btn_alerts.color = "#5cb85c";
                class_btn_alerts_m.color = "#5cb85c";
              }

              if (doc.data().c_interpretacion == "Muy alto") {
                class_btn_outline.border = "3px solid #d9534f";
                class_btn_outline.color = "#d9534f";
                class_btn_outline_m.color = "#d9534f";
              } else if (doc.data().em_interpretacion == "Alto") {
                class_btn_outline.border = "3px solid #f0ad4e";
                class_btn_outline.color = "#f0ad4e";
                class_btn_outline_m.color = "#f0ad4e";
              } else if (doc.data().em_interpretacion == "Medio") {
                class_btn_outline.border = "3px solid #5cb85c";
                class_btn_outline.color = "#5cb85c";
                class_btn_outline_m.color = "#5cb85c";
              } else if (doc.data().em_interpretacion == "Bajo") {
                class_btn_outline.border = "3px solid #5cb85c";
                class_btn_outline.color = "#5cb85c";
                class_btn_outline_m.color = "#5cb85c";
              }
            }

            if (change.doc.data().em_eliminacion) {
              em_eliminacion = change.doc.data().em_eliminacion;
            }
            if (change.doc.data().em_sustitucion) {
              em_sustitucion = change.doc.data().em_sustitucion;
            }
            if (change.doc.data().em_controles_ing) {
              em_controles_ing = change.doc.data().em_controles_ing;
            } else if (change.doc.data().em_control_ingenieria) {
              em_controles_ing = change.doc.data().em_control_ingenieria;
            }
            if (change.doc.data().em_controles) {
              em_controles_admin = change.doc.data().em_controles;
            } else if (change.doc.data().em_controles_admin) {
              em_controles_admin = change.doc.data().em_controles_admin;
            }
            if (change.doc.data().em_equipos) {
              em_equipos = change.doc.data().em_equipos;
            } else if (change.doc.data().em_epp) {
              em_equipos = change.doc.data().em_epp;
            }

            this.id_proceso_movil = doc.data().em_id_proceso;
            this.id_zona_movil = doc.data().em_id_zona;
            this.id_actividad_movil = doc.data().em_id_acti;
            this.id_tareas_movil = doc.data().em_id_tareas;

            this.proceso_riesgo_movil = doc.data().em_proceso;
            this.zona_movil = doc.data().em_zona;
            this.actividad_movil = doc.data().em_actividad;
            this.tarea_movil = em_tarea;
            this.rutinario_peligro_movil = rutinario;

            this.id_matriz_movil = doc.id;
            this.id_peligro_movil = doc.data().em_id_peligro;
            this.clasificacion_movil = doc.data().em_clasificacion;
            this.id_subcla_movil = doc.data().em_id_subclasificacion;
            this.subclasificacion_movil = doc.data().em_tipo;
            this.descripcion_movil = doc.data().em_descripcion;

            this.id_efectos_posibles_movil = doc.data().em_id_efectos_posibles;
            this.efecto_posible_movil = em_efecto_posible;

            this.fuente_movil = doc.data().em_c_fuente;
            this.medio_movil = doc.data().em_c_medio;

            this.individuo_movil = doc.data().em_c_individuo;
            this.antecedente_movil = doc.data().em_antecedente;
            this.class_btn_outline_movil = class_btn_outline;
            this.class_btn_outline_m = class_btn_outline_m;
            this.class_btn_alerts_movil = class_btn_alerts;
            this.class_btn_alerts_m = class_btn_alerts_m;
            this.aceptabilidad_movil = em_aceptabilidad;

            this.num_expuestos_movil = doc.data().em_num_expuestos;
            this.peor_consecuencia_movil = doc.data().em_peor_consecuencia;
            this.requisito_legal_movil = em_requisito_legal;

            this.eliminacion_movil = em_eliminacion;
            this.sustitucion_movil = em_sustitucion;
            this.controles_ing_movil = em_controles_ing;
            this.controles_admin_movil = em_controles_admin;
            this.equipos_movil = em_equipos;
          } else {
            console.log("No se encontró la información.");
          }
        })
        .catch((error) => {
          console.log("Error al obtener la información:", error);
        });
    },
  },
};
</script>